import { render, staticRenderFns } from "./ReportIndividualTable.vue?vue&type=template&id=159b4664&scoped=true&"
import script from "./ReportIndividualTable.vue?vue&type=script&lang=js&"
export * from "./ReportIndividualTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportIndividualTable.vue?vue&type=style&index=0&id=159b4664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b4664",
  null
  
)

export default component.exports